import React from 'react';
import Authorize from './Authorize';
import { Link } from 'react-router-dom';
import NavDropdown from 'react-bootstrap/NavDropdown';
import SupportOffline from '@awp/components/SupportOffline';
import PropTypes from 'prop-types';

export const AwpMenuItem = ({ to, state, replace, title, permissions, supportOffline, onClick }) => {
  return (
    <SupportOffline supportOffline={supportOffline}>
      <Authorize requires={permissions}>
        <Link to={to} state={state} replace={replace} className="nav-item nav-link" onClick={onClick}>
          {title}
        </Link>
      </Authorize>
    </SupportOffline>
  );
};

AwpMenuItem.propTypes = {
  to: PropTypes.string.isRequired,
  state: PropTypes.any,
  replace: PropTypes.bool,
  title: PropTypes.string.isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string),
  supportOffline: PropTypes.bool,
  onClick: PropTypes.func,
};

export const AwpDropdownMenuItem = ({ to, state, title, permissions, supportOffline, onClick }) => {
  return (
    <SupportOffline supportOffline={supportOffline}>
      <Authorize requires={permissions}>
        <NavDropdown.Item to={to} state={state} as={Link} onClick={onClick}>
          {title}
        </NavDropdown.Item>
      </Authorize>
    </SupportOffline>
  );
};

AwpDropdownMenuItem.propTypes = {
  to: PropTypes.any.isRequired,
  state: PropTypes.any,
  title: PropTypes.string.isRequired,
  permissions: PropTypes.arrayOf(PropTypes.string),
  supportOffline: PropTypes.bool,
  onClick: PropTypes.func,
};

export const AwpNavDropdown = ({ title, id, supportOffline, children, className }) => {
  return (
    <SupportOffline supportOffline={supportOffline}>
      <NavDropdown title={title} id={id} className={className}>
        {children}
      </NavDropdown>
    </SupportOffline>
  );
};

AwpNavDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  supportOffline: PropTypes.bool,
  children: PropTypes.any,
};
